// frontend/src/tabs/capEvent.js
//
// The "tab cap reached" signal. Openers (useTabs().openTab, TabLink) emit it
// when open() throws TabCapError; the shell toast (components/common/AppToast)
// listens and shows the message. A window event so the emitter needs no
// import from the listener's tree.

export const CAP_EVENT = 'manexys:tabs:cap-reached';

// Pairs with the listener in AppToast.
export function emitTabCapReached() {
  window.dispatchEvent(new CustomEvent(CAP_EVENT));
}
